/**
 * Image Hotspots Block - Registration
 *
 * @package BrandyBlocks
 */

import { registerBlockType } from "@wordpress/blocks";
import Edit from "./edit";
import Save from "./save";
import metadata from "./block.json";
import "./style.scss";
import "./editor.scss";

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: "#0061FE",
		src: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
				<circle cx="8" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
				<circle cx="8" cy="10" r="1" fill="currentColor"/>
				<circle cx="16" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
				<circle cx="16" cy="7" r="1" fill="currentColor"/>
				<circle cx="13" cy="16" r="2.5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
				<circle cx="13" cy="16" r="1" fill="currentColor"/>
			</svg>
		),
	},
} );
